type UserLike = Record<string, unknown>

const USER_REGISTRATION_NUMBER_KEYS = [
  'usr_reg_num',
  'reg_no',
  'registration_number',
  'user_registration_number',
  'registration_no',
  'reg_number',
]

function asUserRecord(user: unknown): UserLike | null {
  return user && typeof user === 'object' ? user as UserLike : null
}

export function getUserRegistrationNumber(user: unknown): string {
  const record = asUserRecord(user)
  if (!record) {
    return ''
  }

  for (const key of USER_REGISTRATION_NUMBER_KEYS) {
    const value = String(record[key] ?? '').trim()
    if (value) {
      return value
    }
  }

  return ''
}

export function getUserDisplayName(user: unknown, fallbackId?: string | number | null): string {
  const record = asUserRecord(user)
  const firstName = String(record?.fname ?? '').trim()
  const lastName = String(record?.lname ?? '').trim()
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim()
  if (fullName) {
    return fullName
  }

  const name = String(record?.name ?? record?.full_name ?? record?.display_name ?? '').trim()
  if (name) {
    return name
  }

  const username = String(record?.username ?? '').trim()
  if (username) {
    return username
  }

  const id = fallbackId ?? record?.id ?? record?.user_id
  return id !== undefined && id !== null && String(id).trim() ? `User ${id}` : 'User'
}

export function getUserDropdownLabel(user: unknown, fallbackId?: string | number | null): string {
  const name = getUserDisplayName(user, fallbackId)
  const registrationNumber = getUserRegistrationNumber(user)
  return registrationNumber ? `${name} • ${registrationNumber}` : name
}

export function getUserDropdownKeywords(user: unknown): string {
  const record = asUserRecord(user)
  if (!record) {
    return ''
  }

  return [
    record.username,
    record.fname,
    record.lname,
    record.name,
    record.full_name,
    record.display_name,
    getUserRegistrationNumber(record),
    record.phone,
    record.user_group_title,
  ]
    .filter(Boolean)
    .join(' ')
}